export const CREATED_AT_DATE_PRESET = {
  DAYS_1: '1d',
  DAYS_7: '7d',
  DAYS_30: '30d',
  DAYS_90: '90d',
  DAYS_365: '365d',
  SINCE_LOGIN: 'since-login',
  CUSTOM: 'custom',
} as const;

export type CreatedAtDatePreset =
  (typeof CREATED_AT_DATE_PRESET)[keyof typeof CREATED_AT_DATE_PRESET];

export const CREATED_AT_DATE_PRESET_VALUES = [
  CREATED_AT_DATE_PRESET.DAYS_1,
  CREATED_AT_DATE_PRESET.DAYS_7,
  CREATED_AT_DATE_PRESET.DAYS_30,
  CREATED_AT_DATE_PRESET.DAYS_90,
  CREATED_AT_DATE_PRESET.DAYS_365,
  CREATED_AT_DATE_PRESET.SINCE_LOGIN,
  CREATED_AT_DATE_PRESET.CUSTOM,
] as const;

export type DurationCreatedAtDatePreset = Exclude<
  CreatedAtDatePreset,
  | typeof CREATED_AT_DATE_PRESET.SINCE_LOGIN
  | typeof CREATED_AT_DATE_PRESET.CUSTOM
>;

export const CREATED_AT_DATE_URL_PARAMS = {
  preset: 'createdDatePreset',
  startDate: 'createdStartDate',
  endDate: 'createdEndDate',
} as const;

export const CREATED_AT_DATE_FILTER_ID = 'createdAtDate';

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const CREATED_AT_DATE_PRESET_DAY_OFFSETS: Record<
  DurationCreatedAtDatePreset,
  number
> = {
  [CREATED_AT_DATE_PRESET.DAYS_1]: 1,
  [CREATED_AT_DATE_PRESET.DAYS_7]: 7,
  [CREATED_AT_DATE_PRESET.DAYS_30]: 30,
  [CREATED_AT_DATE_PRESET.DAYS_90]: 90,
  [CREATED_AT_DATE_PRESET.DAYS_365]: 365,
};

export const getCreatedAtDatePresetDurationMs = ({
  preset,
}: {
  preset: DurationCreatedAtDatePreset;
}) => CREATED_AT_DATE_PRESET_DAY_OFFSETS[preset] * MILLISECONDS_PER_DAY;
